export enum EMAIL_VERIFICATION_STATUS {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
}
